import React from 'react';

const Settings: React.FC = () => {
    return (
        <h3 style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto', color: '#F7F9F9' }}>Settings Page</h3>
    );
};

export default Settings;